<template>
  <DialogFormWrapper>
    <template #form>
      <ClientForm
        ref="newClientForm"
        @submitClientForm="submitClientForm"
      />
    </template>
    <template #submit>
      <v-btn
        data-id="submit-new-client-button"
        color="primary"
        type="submit"
        class="form-action"
        :loading="isProcessing"
        @click="$refs.newClientForm.submitClientForm()"
      >
        Dodaj klienta
      </v-btn>
    </template>
  </DialogFormWrapper>
</template>

<script>
import DialogFormWrapper from './Partials/DialogFormWrapper'
import ClientForm from './Partials/ClientForm'
import { mapState, mapActions } from 'vuex'

export default {
  components: {
    ClientForm,
    DialogFormWrapper
  },
  computed: {
    ...mapState({
      isProcessing: state => state.clients.isProcessing
    })
  },
  methods: {
    ...mapActions({
      addNewClient: 'clients/addNewItem',
      getMiddlemen: 'middlemen/getItems',
      closeDialog: 'layout/closeDialog'
    }),
    submitClientForm (params) {
      this.addNewClient({ params })
        .then((client) => {
          if (client.isMiddleman) this.getMiddlemen()
          this.closeDialog()
        })
    }
  }
}
</script>
